import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {SubFormComponent} from '../../../_subform';

@Component({
    selector: 'app-apparatus-card-repair-subform',
    templateUrl: 'apparatus-card-repair-subform.component.html'
})

export class ApparatusCardRepairSubformComponent extends SubFormComponent {
    public formGroupTemplate = this.fb.group({
        place: [''],
        date_begin: [''],
        date_end: [''],
        description: [''],
        is_ignored: [false],
        files: this.fb.array([])
    });

    constructor(
        private fb: FormBuilder
    ) {
        super();
    }
}
